var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping List"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4143 9.40553C20.9393 8.85803 20.251 8.54386 19.5252 8.54386H19.4535C19.0377 4.79886 15.8543 1.8772 12.0002 1.8772C8.14601 1.8772 4.96268 4.79886 4.54685 8.54386H4.50018C3.77518 8.54386 3.08768 8.85803 2.61185 9.40553C2.13601 9.95303 1.92268 10.6789 2.02518 11.398L2.90935 17.5847C3.25935 20.0322 5.38768 21.8772 7.85935 21.8772H16.1668C18.6385 21.8772 20.7668 20.0314 21.1168 17.5847L22.001 11.398C22.1035 10.6797 21.8893 9.95386 21.4143 9.40553ZM12.0002 3.54386C14.9335 3.54386 17.3677 5.72136 17.7735 8.54386H6.22685C6.63268 5.72136 9.06685 3.54386 12.0002 3.54386ZM8.66685 17.7105C8.66685 18.1714 8.29435 18.5439 7.83351 18.5439C7.37268 18.5439 7.00018 18.1714 7.00018 17.7105V12.7105C7.00018 12.2497 7.37268 11.8772 7.83351 11.8772C8.29435 11.8772 8.66685 12.2497 8.66685 12.7105V17.7105ZM12.8335 17.7105C12.8335 18.1714 12.461 18.5439 12.0002 18.5439C11.5393 18.5439 11.1668 18.1714 11.1668 17.7105V12.7105C11.1668 12.2497 11.5393 11.8772 12.0002 11.8772C12.461 11.8772 12.8335 12.2497 12.8335 12.7105V17.7105ZM17.0002 17.7105C17.0002 18.1714 16.6277 18.5439 16.1668 18.5439C15.706 18.5439 15.3335 18.1714 15.3335 17.7105V12.7105C15.3335 12.2497 15.706 11.8772 16.1668 11.8772C16.6277 11.8772 17.0002 12.2497 17.0002 12.7105V17.7105Z",
    fill: "#C5C1B9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingList);
export default __webpack_public_path__ + "static/media/Shopping List.b83e46371ee94f0976d105cdd8922d02.svg";
export { ForwardRef as ReactComponent };